import { html, css, render } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { router, hasAccess, views, ViewRoute } from '../app'
import { inject, Symbols } from '../di'
import { MeStore } from '../stores'
import { Layout, View } from './view'
import { mainStyles } from '../vaadin/main-layout'
import { Router } from '@vaadin/router'

@customElement('kob-main')
export class MainLayout extends Layout {

    @inject(Symbols.stores.me)
    meStore: MeStore

    @property({ type: Object })
    selectedRoute

    static get styles() {
        return [
            mainStyles,
            css`
                vaadin-context-menu {
                    cursor: pointer;
                }
                vaadin-icon {
                    width: 16px;
                    height: 16px;
                    color: var(--lumo-secondary-text-color);
                }
                vaadin-horizontal-layout {
                    justify-content:space-between;
                }
                .content {
                    overflow: hidden;
                    height: calc(100vh - var(--kop-header-height));
                }

                header {
                    width: 100%;
                    height: var(--kop-header-height);
                }
            `
        ]
    }

    handleMenuClicked = async (e) => {
        if (e.target.value === 'logout')
            await this.meStore.logout()
    }

    highlight = (viewRoute) => viewRoute.path === window.location.pathname

    private get menuRoutes(): ViewRoute[] {
        return views.filter((route) => route.title && hasAccess(route))
    }

    selectedMenu = () => this.menuRoutes.findIndex(route => route.path === window.location.pathname)

    selectedChanged = (e) => {
        const route = this.menuRoutes[e.detail.value]
        // Prevent infinite loops
        if (route && route.path !== window.location.pathname)
            Router.go(route.path)
    }

    render() {
        return html`
            <vaadin-app-layout>
                <header slot="navbar">
                    <vaadin-horizontal-layout theme="padding spacing">
                        <layout-item>
                            <svg width="130" height="30" viewBox="0 0 267 72" class="css-1j8o68f">
                                <defs id="SvgjsDefs5088"></defs>
                                <g id="SvgjsG5089" featurekey="symbolFeature-0"
                                    transform="matrix(0.8632926732881946,0,0,0.8632926732881946,-18.17454619701241,-5.43821956424375)"
                                    fill="#0a0a0a">
                                    <g xmlns="http://www.w3.org/2000/svg" fill="none" stroke="black" font-family="Times New Roman"
                                        font-size="16" transform="scale(1 -1)">
                                        <g transform="translate(0 -96)">
                                            <g>
                                                <path
                                                    d="M 21.633,34.925 C 24.973,46.855 40.837,53.71 46.922,66.223 C 49.866,72.279 48.49,83.461 43.464,87.939 C 43.197,88.178 42.09,90.326 43.217,89.521 C 54.416,81.327 63.521,70.509 59.309,60.068 C 53.464,45.577 38.409,38.34 38.519,23.585 C 38.566,17.447 43.088,12.523 48.838,7.375 L 49.073,6.299 C 34.143,10.56 17.742,21.028 21.633,34.925 Z M 59.314,18.723 C 67.987,26.524 73.282,31.263 71.043,40.298 C 73.766,36.119 76.295,30.323 74.135,25.806 C 72.203,21.769 70.28,18.956 63.244,15.02 C 59.515,12.935 56.712,10.677 54.37,6.898 C 54.248,10.853 55.011,14.852 59.314,18.723 Z M 49.686,32.153 C 53.003,38.255 57.845,42.622 62.538,48.882 C 65.869,53.325 68.92,60.704 65.731,66.728 L 65.937,67.016 C 70.824,61.556 71.028,52.654 69.495,46.059 C 67.086,35.69 58.5,31.5 53.511,23.918 C 51.557,20.948 50.446,17.311 51,13.5 C 45.461,18.021 46.717,26.69 49.686,32.153 Z"
                                                    stroke-linejoin="miter" stroke-linecap="round" stroke="none" stroke-width="0.75"
                                                    fill="#0a0a0a" marker-start="none" marker-end="none"
                                                    stroke-miterlimit="79.8403193612775"></path>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                                <g id="SvgjsG5090" featurekey="nameFeature-0"
                                    transform="matrix(1.271965994473578,0,0,1.271965994473578,63.29896065165743,4.280340055264221)"
                                    fill="#0a0a0a">
                                    <path
                                        d="M16.23 40 l-6.4648 -8.4375 l-1.1719 0 l0 8.4375 l-5.6836 0 l0 -30 l5.6836 0 l0 17.656 l1.0547 0 l6.3086 -7.7344 l6.3672 0 l-7.9102 9.3164 l8.6523 10.762 l-6.8359 0 z M36.2552578125 40.39063 c-6.3867 0 -10.996 -3.8867 -10.996 -10.449 c0 -6.5234 4.5703 -10.41 10.996 -10.41 c6.4648 0 11.016 3.8867 11.016 10.41 c0 6.5625 -4.5703 10.449 -11.016 10.449 z M36.1962578125 35.918 c3.2617 0 5.4883 -2.3828 5.4883 -5.9766 s-2.2266 -5.9766 -5.4883 -5.9766 c-3.1445 0 -5.3516 2.3828 -5.3516 5.9766 s2.207 5.9766 5.3516 5.9766 z M64.208953125 19.531 c5.2734 0 9.6484 3.9063 9.6484 10.469 s-4.375 10.469 -9.6484 10.469 c-2.7734 0 -5.1953 -1.1133 -6.3281 -3.0859 l-0.13672 2.6172 l-5.332 0 l0 -30 l5.625 0 l0 12.363 c1.1719 -1.8164 3.5156 -2.832 6.1719 -2.832 z M62.899953124999996 35.8008 c2.9883 0 5.332 -2.207 5.332 -5.8008 c0 -3.6133 -2.3438 -5.8203 -5.332 -5.8203 c-2.9688 0 -5.3125 2.3047 -5.3125 5.8203 s2.3242 5.8008 5.3125 5.8008 z M79.0576609375 40 l0 -30 l5.6836 0 l0 30 l-5.6836 0 z M94.39458125 16.914 c-1.7773 0 -3.2617 -1.4453 -3.2617 -3.2422 c0 -1.7773 1.4844 -3.2227 3.2617 -3.2227 c1.7383 0 3.2227 1.4453 3.2227 3.2227 c0 1.7969 -1.4844 3.2422 -3.2227 3.2422 z M91.52348125 40 l0 -20.078 l5.6641 0 l0 20.078 l-5.6641 0 z M127.7585703125 19.531 c4.2969 0 7.0703 2.1875 7.0703 6.3086 l0 14.16 l-5.625 0 l0 -12.559 c0 -2.3633 -1.4844 -3.3984 -3.1641 -3.3984 c-2.0117 0 -3.7891 1.1523 -3.7891 4.6289 l0 11.328 l-5.6836 0 l0 -12.5 c0 -2.4023 -1.4453 -3.457 -3.2227 -3.457 c-1.9531 0 -3.7695 1.1523 -3.7695 4.9219 l0 11.035 l-5.6055 0 l0 -20.078 l5.6055 0 l0 2.3633 c1.3281 -1.7773 3.3594 -2.7539 5.8203 -2.7539 c2.9102 0 5.0977 1.0547 6.1523 3.0078 c1.4063 -2.0117 3.5547 -3.0078 6.2109 -3.0078 z M160.146609375 29.668 l-0.058594 1.3477 l-14.883 0 c0.23438 3.3398 2.4609 4.9414 5.1367 4.9414 c2.0117 0 3.5742 -0.9375 4.3359 -2.7148 l5.1563 0.76172 c-1.3281 4.0625 -4.9414 6.3867 -9.4531 6.3867 c-6.4844 0 -10.723 -3.8281 -10.723 -10.43 s4.3555 -10.469 10.547 -10.469 c5.6836 0 9.9219 3.1445 9.9414 10.176 z M150.244609375 23.477 c-2.5586 0 -4.3359 1.1914 -4.8828 3.8672 l9.2188 0 c-0.29297 -2.5586 -2.0313 -3.8672 -4.3359 -3.8672 z">
                                    </path>
                                </g>
                            </svg>
                            <span theme="badge error small" style="vertical-align: top">beta</span>
                        </layout-item>
                        <layout-item style="align-items: end;">
                            <vaadin-context-menu open-on="click" .renderer=${this.renderLogoutOptions}>
                                <vaadin-avatar theme="xsmall" img="${this.meStore.profileImage}" name="${this.meStore.fullName}">
                                </vaadin-avatar>
                                <span class="font-medium ms-xs text-s text-secondary">${this.meStore.fullName}</span>
                                <vaadin-icon icon="lumo:angle-down"></vaadin-icon>
                            </vaadin-context-menu>
                        </layout-item>
                    </vaadin-horizontal-layout>
                    <nav>
                        <vaadin-tabs .selected=${this.selectedMenu()} @selected-changed=${this.selectedChanged}>
                            ${this.menuRoutes.map((route, index) => html`
                            <vaadin-tab>${route.title}</vaadin-tab>
                            `)}

                            <div style="display:flex; flex:1; justify-content:flex-end;">
                                <vaadin-horizontal-layout theme="spacing">
                                    <layout-item>
                                        <a href="https://www.buymeacoffee.com/koblime/membership" target="_blank">
                                            <kob-coffee></kob-coffee>
                                        </a>
                                    </layout-item>
                                    <layout-item>
                                        <a href="https://docs.kobli.me" target="_blank">
                                            <vaadin-icon icon="vaadin:question-circle-o" style="width:20px;height:20px;"></vaadin-icon>
                                        </a>
                                    </layout-item>
                                </vaadin-horizontal-layout>
                            </div>
                        </vaadin-tabs>
                    </nav>
                </header>
                <div class="content">
                    <slot></slot>
                </div>
            </vaadin-app-layout>
        `
    }

    private renderLogoutOptions = (root: HTMLElement) => {
        render(html`
            <vaadin-list-box @click=${this.handleMenuClicked}>
                <vaadin-item value="logout" style="cursor:pointer;">Logout</vaadin-item>
            </vaadin-list-box>`
            , root)
    }

    async connectedCallback() {
        await super.connectedCallback()
        // The following triggers a refresh of the tabs so selection is updated
        window.addEventListener('popstate', () =>
            this.selectedRoute = this.menuRoutes.findIndex(route => route?.path === window.location.pathname)
        )
    }
}
